import { CartList } from "../components/CartList/Index";
import { Footer } from "../components/Footer/Index";
import { Header } from "../components/Header/Index";


function CartPage(){
    return(

        <>
            <Header/>
            <CartList/>

            <Footer/>
        </>
    )
}


export default CartPage;